import { mapActions } from 'vuex';
import membershipMixin from '../../common/js/membership-mixin/membership-mixin';

export default {
	data() {
		return {
			searchOpenedInMobile: false,
			navigationMenuOpenedInMobile: false,
			userIsAMember: false
		};
	},
	mixins: [membershipMixin],
	props: {
		ariaHide: {
			required: true
		}
	},
	created() {
		this.initUserIsAMember();
	},
	methods: {
		toggleSearchInMobile() {
			this.searchOpenedInMobile = !this.searchOpenedInMobile;
			this.navigationMenuOpenedInMobile = false;
		},
		toggleNavMenuInMobile() {
			this.navigationMenuOpenedInMobile = !this.navigationMenuOpenedInMobile;
			this.searchOpenedInMobile = false;
		},
		setMembership() {
			this.setMembershipCookie();
			this.setUserIsAMember(true);
			this.$nextTick(()=>{
				this.userIsAMember = true;
			});
		},
		initUserIsAMember() {
			this.userIsAMember = !!this.getMembershipCookie();
			this.setUserIsAMember(this.userIsAMember);
		},
		...mapActions('common', ['setUserIsAMember'])
	}
};
